import React from "react";
import { ISurveyQuestion } from "../../../models/survey/survey-question.model";
import {
    surveyHintWrapper,
    questionMark,
    hintContainer,
    hintHeading,
    surveyHint,
} from "./survey-hint.module.scss";

export interface ISurveyHintProps {
    hint: ISurveyQuestion["hint"];
}

const SurveyHint = ({ hint }: ISurveyHintProps) => {
    return (
        <div className={`${surveyHintWrapper}`}>
            <div className={questionMark}>?</div>
            <div className={hintContainer}>
                <p className={hintHeading}>Wskazówka</p>
                <div className={surveyHint}>{hint}</div>
            </div>
        </div>
    );
};

export default SurveyHint;
